import { BaseGridLayout } from '@lucan/base-ui'
import { CFG_SITUAZIONI_DATI_CONDUCENTE } from 'pages/DatiConducente/utilDatiConducente'
import Testo from '../Testo'
import IconeConducenteProprietario from './IconeConducenteProprietario'

export default function RiassuntoSituazioneDatiConducente(props) {
  const { txt, situazione } = props
  
  const { cfgNome, cfgTitoloRiga1, cfgTitoloRiga2, cfgDescr } = CFG_SITUAZIONI_DATI_CONDUCENTE[situazione]

  return (
    <BaseGridLayout justifySpaceBetween alignCenter>
      <>
        <Testo sx={{ fontSize: '1.25rem' }}>
          {txt(cfgNome)}: {txt(cfgTitoloRiga1)} {txt(cfgTitoloRiga2)}
        </Testo>
        <Testo>{txt(cfgDescr)}</Testo>
      </>
      <IconeConducenteProprietario situazione={situazione} />
    </BaseGridLayout>
  )
}